import * as TLM from '../constants/tlm'

class TopicFilterHelpers {
  getFilter (name, key) {
    switch (name) {
      case 'Airline':
        return {
          subType: [TLM.BRAND],
          label: ['Airline'],
          defaultAction: TLM.OR
        }
      case 'Appliances':
        return {
          subType: [TLM.BRAND],
          label: ['Appliances', 'Applicances'],
          defaultAction: TLM.OR
        }
      case 'Automotive':
        return {
          subType: [TLM.BRAND],
          label: ['Auto', 'Car Rental', 'Gas Station'],
          defaultAction: TLM.OR
        }
      case 'Baby & Kids':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Baby', 'Toys'],
          defaultAction: TLM.OR
        }
      case 'CPG':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Alcohol', 'CPG - AlcoholBeer', 'CPG - Baby', 'CPG - Batteries', 'CPG - Beauty', 'CPG - Beverage', 'CPG - Candy', 'CPG - Condiments', 'CPG - Food', 'CPG - FoodChips', 'CPG - Home', 'CPG - Hygiene', 'CPG - Laundry', 'CPG - Medicine', 'CPG - Office', 'CPG - Outdoor', 'CPG - Personal Care', 'CPG - Pet', 'CPG - Skin Care'],
          defaultAction: TLM.OR
        }
      case 'CPG - Alcohol':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Alcohol'],
          defaultAction: TLM.OR
        }
      case 'CPG - Beauty':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Beauty'],
          defaultAction: TLM.OR
        }
      case 'CPG - Beverage':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Beverage'],
          defaultAction: TLM.OR
        }
      case 'CPG - Candy & Gum':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Candy', 'Gum'],
          defaultAction: TLM.OR
        }
      case 'CPG - Food':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Condiments', 'CPG - Foods'],
          defaultAction: TLM.OR
        }
      case 'CPG - Home & Laundry':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Home', 'CPG - Laundry'],
          defaultAction: TLM.OR
        }
      case 'CPG - Personal Care':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Personal Care'],
          defaultAction: TLM.OR
        }
      case 'CPG - Pet Care':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Pet'],
          defaultAction: TLM.OR
        }
      case 'Entertainment':
        return {
          subType: [TLM.BRAND],
          label: ['Book', 'Entertainment', 'Media Company', 'Movie Studio', 'Streaming Service'],
          defaultAction: TLM.OR
        }
      case 'Finance':
        return {
          subType: [TLM.BRAND],
          label: ['Banking', 'Credit Card', 'Financial'],
          defaultAction: TLM.OR
        }
      case 'Fitness':
        return {
          subType: [TLM.BRAND],
          label: ['Fitness'],
          defaultAction: TLM.OR
        }
      case 'Gaming':
        return {
          subType: [TLM.BRAND],
          label: ['Online Games', 'Video Game'],
          defaultAction: TLM.OR
        }
      case 'Hotel':
        return {
          subType: [TLM.BRAND],
          label: ['Hotel'],
          defaultAction: TLM.OR
        }
      case 'Insurance':
        return {
          subType: [TLM.BRAND],
          label: ['Insurance'],
          defaultAction: TLM.OR
        }
      case 'Media & News':
        return {
          subType: [TLM.BRAND],
          label: ['Magazine', 'Online Video', 'Periodical', 'Radio'],
          defaultAction: TLM.OR
        }
      case 'Pharmaceuticals':
        return {
          subType: [TLM.BRAND],
          label: ['CPG - Medicine'],
          defaultAction: TLM.OR
        }
      case 'Podcasts':
        return {
          subType: [TLM.BRAND],
          label: ['Podcast'],
          defaultAction: TLM.OR
        }
      case 'QSR':
        return {
          subType: [TLM.BRAND],
          label: ['QSR'],
          defaultAction: TLM.OR
        }
      case 'Restaurant':
        return {
          subType: [TLM.BRAND],
          label: ['Restaurant'],
          defaultAction: TLM.OR
        }
      case 'Retail':
        return {
          subType: [TLM.BRAND],
          label: ['Clothing', 'Flowers', 'Jewelry', 'Power Tools', 'Retailers'],
          defaultAction: TLM.OR
        }
      case 'Services':
        return {
          subType: [TLM.BRAND],
          label: ['Diet', 'Logistics', 'Online Dating', 'Service', 'Storage'],
          defaultAction: TLM.OR
        }
      case 'Technology':
        return {
          subType: [TLM.BRAND],
          label: ['Computers', 'Media', 'NonProfit', 'Photography', 'Software', 'Streaming Service', 'Tech'],
          defaultAction: TLM.OR
        }
      case 'Telecommunication':
        return {
          subType: [TLM.BRAND],
          label: ['Telecommunications'],
          defaultAction: TLM.OR
        }
      case 'Travel':
        return {
          subType: [TLM.BRAND],
          label: ['Online Travel', 'Travel'],
          defaultAction: TLM.OR
        }
      case 'Industrial':
        return {
          subType: [TLM.BRAND],
          label: ['Energy', 'Manufacturing'],
          defaultAction: TLM.OR
        }
      case 'Real Estate':
        return {
          subType: [TLM.BRAND],
          label: ['Real Estate'],
          defaultAction: TLM.OR
        }
      default:
        return {
          subType: key === TLM.TLM_BRAND ? [TLM.BRAND] : [TLM.SHOW, TLM.MOVIE],
          label: [name],
          defaultAction: TLM.OR
        }
    }
  }
}

const instance = new TopicFilterHelpers()

export default instance
